export default {
  'Advertising/Marketing': [
    'Advertising Agencies',
    'Advertising/Marketing (General)',
    'Broadcasting - Radio',
    'Broadcasting - TV',
    'CATV Systems',
    'Communications',
    'Entertainment',
    'Event Management',
    'Marketing Services',
    'Movie Production/Theaters',
    'PR',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Aerospace/Aviation': [
    'Aerospace/Aviation (General)',
    'Aerospace/Defense - Major Diversified',
    'Aerospace/Defense Products & Services',
    'Air Delivery & Freight Services',
    'Air Services',
    'Major Airlines',
    'Regional Airlines',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Agriculture: ['Agriculture (General)', 'Dairy', 'Farming', 'Fishery', 'Ranching'].map((item) => ({
    label: item,
    value: item,
  })),
  Automotive: [
    'Auto Dealerships',
    'Auto Manufacturers',
    'Auto Parts',
    'Auto Parts Stores',
    'Auto Parts Wholesale',
    'Automotive (General)',
    'Recreational Vehicles',
    'Tires',
    'Trucks/Other Vehicles',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Biotech and Pharmaceuticals': [
    'Biotech and Pharmaceuticals (General)',
    'Clinical Laboratory',
    'Life Sciences Manufacturing',
    'Pharmaceuticals',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Computers and Technology': [
    'Computer Hardware',
    'Computer Networking',
    'Computer Software',
    'Computer/Network Security',
    'Computers and Technology (General)',
    'Information Technology/Services',
    'Internet',
    'Nanotechnology',
    'Semiconductors',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Construction: [
    'Architecture/Planning',
    'Building Materials',
    'Civil Engineering',
    'Construction',
    'Construction (General)',
    'Electrical Engineering',
    'Glass/Ceramics/Concrete',
    'Industrial Automation',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Corporate Services': [
    'Business Supplies/Equipment',
    'Corporate Services (General)',
    'E-Learning',
    'Human Resources',
    'Legal Services',
    'Management Consulting',
    'Market Research',
    'Outsourcing/Offshoring',
    'Professional Training',
    'Program Development',
    'Staffing/Recruiting',
    'Translation/Localization',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Education: [
    'E-Learning',
    'Education (General)',
    'Education Management',
    'Higher Education',
    'K-12',
    'Research',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Finance: [
    'Accounting',
    'Banking',
    'Capital Markets',
    'Credit Unions',
    'Finance (General)',
    'Financial Services',
    'Investment Banking/Venture',
    'Investment Management',
    'Venture Capital',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Government: [
    'Department of Defense (Civilian)',
    'Department of Defense (Military)',
    'Federal Government',
    'Government (General)',
    'Government Contractor',
    'Private Sector',
    'State/Local Government',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Healthcare/Medical': [
    'Alternative Medicine',
    'Health/Wellness/Fitness',
    'Healthcare/Medical (General)',
    'Hospital/Healthcare',
    'Veterinary',
    'Healthcare Policy',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Insurance: [
    'Agriculture',
    'Automotive',
    'Health',
    'Insurance (General)',
    'Life',
    'Property & Casualty',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Legal: [
    'Corporate Legal',
    'Judiciary',
    'Law Practice',
    'Legal (General)',
    'Legal Services',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Manufacturing: [
    'Business Supplies/Equipment',
    'Chemicals',
    'Consumer Electronics',
    'Consumer Goods',
    'Electrical/Electronic Manufacturing',
    'Food & Beverage Production',
    'Furniture',
    'Glass/Ceramics/Concrete',
    'Industrial Automation',
    'Machinery',
    'Manufacturing (General)',
    'Mechanical/Industrial Engineering',
    'Mining/Metals',
    'Packaging/Containers',
    'Paper/Forest Products',
    'Plastics',
    'Shipbuilding',
    'Textiles',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Media: [
    'Animation',
    'Arts/Crafts',
    'Audio/Music',
    'Broadcast Media',
    'Computer Games',
    'Design',
    'Fine Art',
    'Graphic Design',
    'Information Services',
    'Libraries',
    'Media (General)',
    'Media Production',
    'Motion Pictures/Film',
    'Newspapers',
    'Online Publishing',
    'Photography',
    'Printing',
    'Publishing',
    'Writing/Editing',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Non-Profit/Organizations': [
    'Alternative Dispute Resolution',
    'Civic/Social Organization',
    'Consumer Services',
    'Environmental Services',
    'Fundraising',
    'Individual/Family Services',
    'Non-Profit Organization Management',
    'Philanthropy',
    'Political Organization',
    'Program Development',
    'Religious Institutions',
    'Security / Investigations',
    'Think Tanks',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Real Estate': [
    'Commercial Real Estate',
    'Mortgage',
    'Property Management',
    'Real Estate (General)',
    'Residential Real Estate',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Retail and Consumer Goods': [
    'Apparel/Fashion',
    'Consumer Electronics',
    'Consumer Goods',
    'Cosmetics',
    'Food Production',
    'Furniture',
    'Luxury Goods/Jewelry',
    'Manufacturing Retail',
    'Packaging/Containers',
    'Retail',
    'Retail and Consumer Goods (General)',
    'Sporting Goods',
    'Supermarkets',
    'Tobacco',
    'Wholesale',
    'Wine/Spirits',
    'eCommerce',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Service Industry': [
    'Alternative Dispute Resolution',
    'Events Services',
    'Facilities Services',
    'Food/Beverages',
    'Package/Freight Delivery',
    'Restaurants',
    'Security/Investigations',
    'Service Industry (General)',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Telecommunications: [
    'Cable and Other Program Distribution',
    'Communication Equipment',
    'Diversified Communication Services',
    'Long Distance Carriers',
    'Paging',
    'Processing Systems/Products',
    'Satellite Telecommunications',
    'Telecom Services - Domestic',
    'Telecom Services - Foreign',
    'Telecommunications (General)',
    'Wired Telecommunications Carriers',
    'Wireless Communications',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Transportation and Logistics': [
    'Import/Export',
    'International Trade/Development',
    'Logistics/Supply Chain',
    'Maritime',
    'Package/Freight Delivery',
    'Translation/Localization',
    'Transportation and Logistics (General)',
    'Transportation/Trucking/Railroad',
    'Warehousing',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Travel/Hospitality/Entertainment': [
    'Entertainment',
    'Food/Beverages',
    'Gambling/Casinos',
    'Hospitality',
    'Leisure/Travel',
    'Museums/Institutions',
    'Music',
    'Performing Arts',
    'Recreational Facilities/Services',
    'Restaurants',
    'Sports',
    'Travel/Hospitality/Entertainment (General)',
    'Wine/Spirits',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Utility/Energy': [
    'Electrical Power',
    'Gas',
    'Nuclear',
    'Oil',
    'Petroleum',
    'Power Distributors',
    'Power Generation',
    'Renewable Energy',
    'Utility/Energy (General)',
    'Waste Management',
    'Water Treatment',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Other: ['Other'].map((item) => ({ label: item, value: item })),
};
